import actions from './actions'

const initialState = {
  menuLeftData: [],
  menuTopData: [],
  selectedOption: null,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case actions.SELECTED_OPTION:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
